import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../estilos.css';
import {
    listRecibaSerialess
} from '../../graphql/queries';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment, { updateLocale } from 'moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink, CSVDownload } from "react-csv";
import { GetClientes, GetRecibaSeriales, GetRecibaSerialesID, GetRecibaSerialesMP } from '../queries/Queries';
import { deleteRecibaSerialesMP, updateRecibaSeriales } from '../../graphql/mutations';
import { marcarMaterialFueradePlanta } from '../queries/Mutations';




function RIClinentes() {
    //Declaración de variables                
    const [recibaSeriales, setRecibaSeriales] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [clienteElejidoN, setClienteElejidoN] = useState([]);
    const [clienteElejido, setClienteElejido] = useState([]);
    const [recibaIMP, setRecibaIMP] = useState([]);
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pRProducciones = window.$ProduccionReporteSema ? window.$ProduccionReporteSema : false;
    const ppmarcarFueraPlanta = window.$MarcarFueradePlanta ? window.$MarcarFueradePlanta : false;
    const [cargando, setCargando] = useState(false);
    const [aVisible, setAVisible] = useState(false);
    const [sumProduccionp, setSumProduccionp] = useState("");
    const [sumICiclos, setSumICiclos] = useState("");
    //const [dia, setDia] = useState("");
    const [fPDisabled, setFPDisabled] = useState(true);
    const onDismiss = () => setAVisible(false);
    const [paginasP, setPaginasP] = useState([]);
    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();

    const dia = new Date().getDay();
    now2.setDate(now2.getDate() - dia);
    now.setDate(now.getDate() + (6 - dia));

    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    //Método useEffect
    useEffect(() => {
        fetchClientes();
    }, []);
    //Función que sirve para obtener los datos de una búsqueda.
    async function busquedaReciba(recibasinfiltro) {
        //Variables donde se agrupan los datos para mostrarlos e imprimirlos
        var recibaSerialesANP = [];
        //Variable donde se guardan los datos para descargarlos.
        var recibaSerialesIMP = [];
        //Se obtienen los datos ordenados por número de parte
        var recibaSerialesSOANP = await recibasinfiltro.sort((a, b) =>
            a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0);

        //Variables auxiliares para sumar cantidades.        
        var cantidadPlaneada = parseFloat(recibaSerialesSOANP[0].cantidadPlaneada ? recibaSerialesSOANP[0].cantidadPlaneada : 0);
        var sumCandidadR = parseFloat(recibaSerialesSOANP[0].cantidadRecibida ? recibaSerialesSOANP[0].cantidadRecibida : 0);
        var piezasCarga = parseFloat(recibaSerialesSOANP[0].piezasenCarga ? recibaSerialesSOANP[0].piezasenCarga : 0);
        var piezasPintadas = parseInt(recibaSerialesSOANP[0].piezasPintadas ? recibaSerialesSOANP[0].piezasPintadas : 0);
        var piezasRecuperacion = parseFloat(recibaSerialesSOANP[0].piezasTRecuperacion ? recibaSerialesSOANP[0].piezasTRecuperacion : 0);
        var piezasInspeccionadas = parseFloat((recibaSerialesSOANP[0].piezasInspeccion ? recibaSerialesSOANP[0].piezasInspeccion : 0) +
            (recibaSerialesSOANP[0].piezasIRecuperacion ? recibaSerialesSOANP[0].piezasIRecuperacion : 0));
        var piezasAEmbarcar = parseFloat(recibaSerialesSOANP[0].piezasAEmbarcar ? recibaSerialesSOANP[0].piezasAEmbarcar : 0);
        var piezasAEmbarcadas = parseInt(recibaSerialesSOANP[0].piezasEmbarcadas ? recibaSerialesSOANP[0].piezasEmbarcadas : 0);
        var piezasenAlmacen = parseFloat(recibaSerialesSOANP[0].piezasenAlmacen ? recibaSerialesSOANP[0].piezasenAlmacen : 0);

        //Se suman todos los datos, como corresponde.
        await Promise.all(recibaSerialesSOANP.map(async (recibaseriales, j) => {
            //Si no se ha llegado al final del array
            if (recibaSerialesSOANP.length > j + 1) {
                //Si el número de parte del registro actual es igual al siguiente, es del mismo cliente y tiene la misma descripción
                if (recibaseriales.numerodeParte === recibaSerialesSOANP[j + 1].numerodeParte && recibaseriales.cliente === recibaSerialesSOANP[j + 1].cliente &&
                    recibaseriales.descripcion === recibaSerialesSOANP[j + 1].descripcion) {

                    //Se suman los datos                    
                    cantidadPlaneada = cantidadPlaneada + parseFloat(recibaSerialesSOANP[j + 1].cantidadPlaneada ? recibaSerialesSOANP[j + 1].cantidadPlaneada : 0);
                    sumCandidadR = sumCandidadR + parseFloat(recibaSerialesSOANP[j + 1].cantidadRecibida ? recibaSerialesSOANP[j + 1].cantidadRecibida : 0);
                    piezasCarga = piezasCarga + parseFloat(recibaSerialesSOANP[j + 1].piezasenCarga ? recibaSerialesSOANP[j + 1].piezasenCarga : 0);
                    piezasPintadas = piezasPintadas + parseInt(recibaSerialesSOANP[j + 1].piezasPintadas ? recibaSerialesSOANP[j + 1].piezasPintadas : 0);
                    piezasRecuperacion = piezasRecuperacion + parseFloat(recibaSerialesSOANP[j + 1].piezasTRecuperacion ? recibaSerialesSOANP[j + 1].piezasTRecuperacion : 0);
                    piezasInspeccionadas = piezasInspeccionadas + parseFloat((recibaSerialesSOANP[j + 1].piezasInspeccion ? recibaSerialesSOANP[j + 1].piezasInspeccion : 0) +
                        (recibaSerialesSOANP[j + 1].piezasIRecuperacion ? recibaSerialesSOANP[j + 1].piezasIRecuperacion : 0));
                    piezasAEmbarcar = piezasAEmbarcar + parseFloat(recibaSerialesSOANP[j + 1].piezasAEmbarcar ? recibaSerialesSOANP[j + 1].piezasAEmbarcar : 0);
                    piezasAEmbarcadas = piezasAEmbarcadas + parseFloat(recibaSerialesSOANP[j + 1].piezasEmbarcadas ? recibaSerialesSOANP[j + 1].piezasEmbarcadas : 0);
                    piezasenAlmacen = piezasenAlmacen + parseFloat(recibaSerialesSOANP[j + 1].piezasenAlmacen ? recibaSerialesSOANP[j + 1].piezasenAlmacen : 0);


                } else {
                    recibaSerialesANP.push({
                        ...recibaseriales, cantidadRecibida: sumCandidadR, piezasenCarga: piezasCarga,
                        piezasPintadas: piezasPintadas, cantidadPlaneada: cantidadPlaneada, piezasTRecuperacion: piezasRecuperacion,
                        piezasInspeccion: piezasInspeccionadas, piezasAEmbarcar: piezasAEmbarcar, piezasEmbarcadas: piezasAEmbarcadas,
                        piezasenAlmacen: piezasenAlmacen
                    });
                    //Array para imprimir
                    recibaSerialesIMP.push({
                        Cliente: recibaseriales.cliente, ["Número de parte"]: recibaseriales.numerodeParte, Descripción: recibaseriales.descripcion,
                        ["Cantidad recibida"]: sumCandidadR, ["Piezas cargadas"]: piezasCarga ? piezasCarga : 0, ["Piezas pintadas"]: piezasPintadas ? piezasPintadas : 0,
                        ["Piezas en recuperación"]: piezasRecuperacion ? piezasRecuperacion : 0,
                        ["Piezas inspeccionadas"]: piezasInspeccionadas, ["Piezas a embarcar"]: piezasAEmbarcar ? piezasAEmbarcar : 0, ["Piezas embarcadas"]: piezasAEmbarcadas ? piezasAEmbarcadas : 0,
                        ["Piezas en almacen"]: piezasenAlmacen ? piezasenAlmacen : 0
                    });

                    cantidadPlaneada = parseFloat(recibaSerialesSOANP[j + 1].cantidadPlaneada ? recibaSerialesSOANP[j + 1].cantidadPlaneada : 0);
                    sumCandidadR = parseFloat(recibaSerialesSOANP[j + 1].cantidadRecibida ? recibaSerialesSOANP[j + 1].cantidadRecibida : 0);
                    piezasCarga = parseFloat(recibaSerialesSOANP[j + 1].piezasenCarga ? recibaSerialesSOANP[j + 1].piezasenCarga : 0);
                    piezasPintadas = parseInt(recibaSerialesSOANP[j + 1].piezasPintadas ? recibaSerialesSOANP[j + 1].piezasPintadas : 0);
                    piezasRecuperacion = parseFloat(recibaSerialesSOANP[j + 1].piezasTRecuperacion ? recibaSerialesSOANP[j + 1].piezasTRecuperacion : 0);
                    piezasInspeccionadas = parseFloat((recibaSerialesSOANP[j + 1].piezasInspeccion ? recibaSerialesSOANP[j + 1].piezasInspeccion : 0) +
                        (recibaSerialesSOANP[j + 1].piezasIRecuperacion ? recibaSerialesSOANP[j + 1].piezasIRecuperacion : 0));
                    piezasAEmbarcar = parseFloat(recibaSerialesSOANP[j + 1].piezasAEmbarcar ? recibaSerialesSOANP[j + 1].piezasAEmbarcar : 0);
                    piezasAEmbarcadas = parseFloat(recibaSerialesSOANP[j + 1].piezasEmbarcadas ? recibaSerialesSOANP[j + 1].piezasEmbarcadas : 0);
                    piezasenAlmacen = parseFloat(recibaSerialesSOANP[j + 1].piezasenAlmacen ? recibaSerialesSOANP[j + 1].piezasenAlmacen : 0);

                }
            } else {
                recibaSerialesANP.push({
                    ...recibaseriales, cantidadRecibida: sumCandidadR, piezasenCarga: piezasCarga,
                    piezasPintadas: piezasPintadas, cantidadPlaneada: cantidadPlaneada, piezasTRecuperacion: piezasRecuperacion,
                    piezasInspeccion: piezasInspeccionadas, piezasAEmbarcar: piezasAEmbarcar, piezasEmbarcadas: piezasAEmbarcadas,
                    piezasenAlmacen: piezasenAlmacen
                });
                //Array para imprimir
                recibaSerialesIMP.push({
                    Cliente: recibaseriales.cliente, ["Número de parte"]: recibaseriales.numerodeParte, Descripción: recibaseriales.descripcion,
                    ["Cantidad recibida"]: sumCandidadR, ["Piezas cargadas"]: piezasCarga ? piezasCarga : 0, ["Piezas pintadas"]: piezasPintadas ? piezasPintadas : 0,
                    ["Piezas en recuperación"]: piezasRecuperacion ? piezasRecuperacion : 0,
                    ["Piezas inspeccionadas"]: piezasInspeccionadas, ["Piezas a embarcar"]: piezasAEmbarcar ? piezasAEmbarcar : 0, ["Piezas embarcadas"]: piezasAEmbarcadas ? piezasAEmbarcadas : 0,
                    ["Piezas en almacen"]: piezasenAlmacen ? piezasenAlmacen : 0
                });
            }

            return recibaseriales;
        }));

        recibasinfiltro = recibaSerialesANP;

        setRecibaSeriales(recibasinfiltro);
        setRecibaIMP(recibaSerialesIMP);
    }
    //Obtiene los datos guardados de los planes de producción
    async function fetchReciba(clienteID) {
        //Filtro por planeación activa        
        setCargando(true);
        let filter = {
            and: [{
                activo: {
                    eq: true
                }
            },
            {
                clienteID: {
                    eq: clienteID
                }
            },
            {
                piezasEnPlanta: {
                    eq: true
                }
            }]
        }
        const cliente = clientes.filter(clienteE => clienteE.id === clienteID)
        setClienteElejidoN(cliente[0].cliente);
        const apiData = await GetRecibaSerialesMP(filter);
        var reporte = [];
        const pProduccionFromAPI = apiData.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0);
        await Promise.all(pProduccionFromAPI.map(async (reciba, i) => {
            reciba.enCarga = ((reciba.piezasenCarga ? reciba.piezasenCarga : 0) -
                (reciba.piezasenPintado ? reciba.piezasenPintado : 0));

            reciba.enPintado = (reciba.piezasenPintado ? reciba.piezasenPintado -
                ((reciba.piezasInspeccion ? reciba.piezasInspeccion : 0) +
                    (reciba.piezasIRecuperacion ? reciba.piezasIRecuperacion : 0)) : 0);

            reciba.enInspeccion = (reciba.piezasInspeccion ? (parseInt(reciba.piezasInspeccion) +
                parseInt(reciba.piezasRecuperadas ? reciba.piezasRecuperadas : 0)
                + parseInt(reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0)) -
                (parseInt(reciba.piezasCalidad ? reciba.piezasCalidad : 0) +
                    parseInt(reciba.piezasCRecuperacion ? reciba.piezasCRecuperacion : 0) +
                    (parseInt(reciba.piezasNoAceptadas ? reciba.piezasNoAceptadas : 0) * 2)) : 0);

            reciba.enRecuperacion = (reciba.piezasTRecuperacion ? reciba.piezasTRecuperacion -
                ((reciba.piezasRecuperadas ? reciba.piezasRecuperadas : 0) +
                    (reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0) -
                    parseInt(reciba.piezasNoAceptadas ? reciba.piezasNoAceptadas : 0)) : 0);
            reciba.enCuarentena = (reciba.piezasenCuarentena ? reciba.piezasenCuarentena : 0) -
                (reciba.piezasCtnaNAEmbarcar ? reciba.piezasCtnaNAEmbarcar : 0) -
                (reciba.PiezasCtnaRecuperacion ? reciba.PiezasCtnaRecuperacion : 0) -
                (reciba.piezasCtnaPintadas ? reciba.piezasCtnaPintadas : 0)


            /**----------------------- */
            reciba.ECuarentena = (reciba.enCuarentena ?
                reciba.cantidadRecibida === reciba.enCuarentena ? "Cuarentena " :
                    "Cuarentena " + reciba.enCuarentena : "");

            reciba.EAlmacen = ((reciba.piezasenAlmacen ? reciba.piezasenAlmacen : 0)
                === reciba.cantidadRecibida ? "Almacén" :
                (reciba.piezasenAlmacen ? reciba.piezasenAlmacen : 0) > 0 ?
                    " Almacén" + reciba.piezasenAlmacen : "")

            reciba.Ecarga = reciba.enCarga > 0 ? reciba.cantidadRecibida === reciba.enCarga ? " Producción " :
                (" Producción " + reciba.enCarga) : "";

            reciba.EInspeccion = ((reciba.enPintado ? reciba.enPintado : 0) + (reciba.enInspeccion ? reciba.enInspeccion : 0)) > 0 ?
                ((reciba.enPintado ? reciba.enPintado : 0) + (reciba.enInspeccion ? reciba.enInspeccion : 0)) === reciba.cantidadRecibida ? " Inspección " :
                    (" Inspección " + ((reciba.enPintado ? reciba.enPintado : 0) + (reciba.enInspeccion ? reciba.enInspeccion : 0))) : "";

            reciba.ERecuperacion = reciba.enRecuperacion > 0 ?
                reciba.enRecuperacion === reciba.cantidadRecibida ? " Recuperación " :
                    (" Recuperación " + reciba.enRecuperacion) : "";

            reciba.ETerminado = ((reciba.cantidadRecibida ? reciba.cantidadRecibida : 0) -
                (reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0)) === 0 ?
                reciba.cantidadRecibida === reciba.piezasAEmbarcar ? "Terminado" :
                    " Terminado " + ((reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0)) :
                (reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0) > 0 ? " Terminado " +
                    (reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0) : "";

            reciba.EEmbarcado = (reciba.piezasEmbarcadas ? reciba.piezasEmbarcadas : 0) > 0 ?
                " Embarcado " + (reciba.piezasEmbarcadas ? reciba.piezasEmbarcadas : 0) : "";
            reciba.EEstatus = reciba.status === "En reciba" ? "En reciba" : reciba.ECuarentena + reciba.EAlmacen + reciba.Ecarga + reciba.EInspeccion + reciba.ERecuperacion + reciba.ETerminado + reciba.EEmbarcado;
            const restFechas = (new Date()).getTime() - (new Date(reciba.fechaDeReciba)).getTime();
            reciba.FEPlanta = Math.round(restFechas / (1000 * 60 * 60 * 24));
            //-----------------------------------------
            reporte.push({
                ["Número"]: i + 1
                , ["Cliente"]: reciba.cliente
                , ["Número de parte"]: reciba.numerodeParte
                , ["Descripción"]: reciba.descripcion
                , ["Fecha de reciba"]: reciba.fechaDeReciba
                , ["Días en la planta"]: reciba.FEPlanta
                , ["Packing"]: reciba.packing
                , ["Lote"]: reciba.lote
                , ["Serial"]: reciba.serial
                , ["Serial BTI"]: reciba.serialRecibaBTI
                , ["Cantidad recibida"]: reciba.cantidadRecibida
                , ["Estatus"]: reciba.EEstatus
                , ["Piezas en cuarentena"]: reciba.ECuarentena ? reciba.ECuarentena : 0
                , ["Cantidad planeada"]: reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0
                , ["Piezas en almacén"]: reciba.piezasenAlmacen ? reciba.piezasenAlmacen : 0
                , ["Piezas en carga"]: reciba.enCarga
                , ["Piezas en pintado"]: reciba.enPintado
                , ["Piezas en inspección"]: reciba.enInspeccion
                , ["En Recuperacion"]: reciba.enRecuperacion
                , ["Piezas a embarcar"]: reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0
                , ["Piezas embarcadas"]: reciba.piezasEmbarcadas ? reciba.piezasEmbarcadas : 0
                , ["Contenedor de reciba"]: reciba.materialEnCantidad + " " + (reciba.materialEnCantidad > 1 ?
                    reciba.materialEn === "caja" ? "cajas" : "contenedores" : reciba.materialEn)
                , ["Recibió"]: reciba.Reg_Ins_Usuario
                , ["Comentarios"]: reciba.comentariosdeinspeccion
            })
            return reciba;
        }))
        setRecibaSinFiltro(pProduccionFromAPI);
        setRecibaSeriales(pProduccionFromAPI);
        setRecibaIMP(reporte);
        /*if (pProduccionFromAPI.length) {
            busquedaReciba(pProduccionFromAPI);
        }*/
        setCargando(false);

    }

    //Revisa cambios en la fecha de búsqueda
    function onChangesRFecha(e) {
        e.persist()
        var fechafin = rfechafin;
        var fechaini = rfechaini;
        if (e.target.name === "fechaIni") {
            setRfechaini(e.target.value);
            fechaini = e.target.value;
        }
        else {
            setRfechafin(e.target.value);
            fechafin = e.target.value;
        }
        fetchReciba(fechaini, fechafin);

    }
    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {
        const clientesFromAPI = await GetClientes();
        setClientes(clientesFromAPI);
    }
    //Revisa cambios en el combo de clientes
    function onChangesClientes(e) {
        if (e.target.value !== "") {
            if (clienteElejido !== e.target.value) {
                fetchReciba(e.target.value);
            }
        } else {
            setRecibaSeriales("");
            setRecibaIMP("");
        }
        setClienteElejido(e.target.value);
    }
    //Procedimiento especial para marcar el material fuera de planta
    async function marcarMaterialFueradePlantal(recibas) {
        setCargando(true);
        setAVisible(false);
        window.scrollTo(0, 0);
        try {
            //Se obtienen los datos de la reciba por ID        
            const mfp = await marcarMaterialFueradePlanta(recibas, userName);
            setMensajeAlert(mfp.mensaje);
            setColor(mfp.color);
            setAVisible(true);
            setCargando(false);
            fetchReciba(clienteElejido);
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(e.message);
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
    }
    return (
        <>
            {pRProducciones == true && (
                <>
                    <div className="conteiner2">
                        <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                            {mensajeAlert}
                        </Alert>
                        {cargando === true && (
                            <Row>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                    <img width="150px" src="assets/img/preloader.gif" />
                                </div>
                            </Row>
                        )}
                        <Fragment>
                            <div>

                                <Row>
                                    {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px" >
                                        {recibaSeriales.length > 0 && (<h5 className=" floatleft">Reporte de producción del {Moment(rfechaini).format("DD/MM/YYYY")} al  {Moment(rfechafin).format("DD/MM/YYYY")}</h5>)}
                                    </div>*/}
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12  ">
                                        <Label className="floatleft">
                                            Cliente:{/*clienteElejido*/}
                                        </Label>
                                        <select name="clienteID" className="floatleft custom-select" onChange={(e) => onChangesClientes(e)}>
                                            <option className="" value="">Elige un cliente</option>
                                            {clientes.map((cliente) => (
                                                <option value={cliente.id} selected={clienteElejido === cliente.id ? true : false}>
                                                    {cliente.cliente}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12  " >
                                        <div className='floatrightleft marginrightmobil3p'>
                                            <button className="cbutton btn-dark  ml-1" title="Recargar página" onClick={() => { fetchReciba(clienteElejido); }}><IoIcons.IoMdRefresh /> Recargar </button>
                                            <button className="cbutton btn-info  ml-1 " title="Imprimir" hidden={recibaSeriales.length ? false : true} onClick={handlePrint}> Imprimir</button>
                                            <button className="cbutton btn-primary  ml-1 " title="Descargar" hidden={recibaSeriales.length ? false : true}>
                                                <CSVLink className='linkfont' data={recibaIMP} filename={"Inventario del cliente " + clienteElejidoN + " " + Moment(new Date()).format("DD/MM/YYYY")}>Descargar</CSVLink>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                    </div>
                                </Row>
                                <Row>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center  ">
                                        <Label className="floatright ml-2 bcolorr"> {"más de 15"}</Label>
                                        <Label className="floatright ml-2 bcolorbb ">{"de 8 a 15"}</Label>
                                        <Label className="floatright ml-2 bcolorlb">{"de 3 a 7"}</Label>
                                        <Label className="floatright ml-2 "> Días en planta: </Label>
                                    </div>

                                </Row>
                                <Row >
                                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper">
                                        <Table className=" mb-2 scroll " >
                                            <Thead className="thead-secondary">
                                                <Tr>
                                                    <Th>Número</Th>
                                                    <Th className="minwidth200px">Cliente</Th>
                                                    <Th className="minwidth200px">Número de parte</Th>
                                                    <Th className="minwidth200px">Descripción</Th>
                                                    <Th className="minwidth200px">Fecha de reciba</Th>
                                                    <Th className="minwidth200px">Días en la planta</Th>
                                                    <Th className="minwidth200px">Packing</Th>
                                                    <Th className="minwidth200px">Lote</Th>
                                                    <Th className="minwidth200px">Serial</Th>
                                                    <Th className="minwidth200px">Serial BTI</Th>
                                                    <Th>Cantidad recibida</Th>
                                                    <Th className="minwidth60px">Estatus</Th>
                                                    <Th className="minwidth60px">Piezas en cuarentena</Th>
                                                    <Th className="minwidth60px">Cantidad planeada</Th>
                                                    <Th className="minwidth60px">Piezas en almacén</Th>
                                                    <Th className="minwidth60px">Piezas en carga</Th>
                                                    <Th className="minwidth60px">Piezas en pintado</Th>
                                                    <Th className="minwidth60px">Piezas en inspección</Th>
                                                    <Th className="minwidth60px">En Recuperacion</Th>
                                                    <Th className="minwidth60px">Piezas a embarcar</Th>
                                                    <Th className="minwidth60px">Piezas embarcadas</Th>
                                                    <Th className="minwidth60px">Contenedor de reciba</Th>
                                                    <Th className="minwidth60px">Recibió</Th>
                                                    <Th className="minwidth60px">Comentarios</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {recibaSeriales.map((reciba, i) => (
                                                    <Tr className={(reciba.FEPlanta >= 3 && reciba.FEPlanta <= 7) ? "bcolorlb" :
                                                        (reciba.FEPlanta >= 8 && reciba.FEPlanta <= 15) ? "bcolorbb" :
                                                            (reciba.FEPlanta > 15) ? "bcolorr" :
                                                                i % 2 !== 0 ? "table-active" : ""}>
                                                        <Td>{i + 1}</Td>
                                                        <Td>{reciba.cliente}</Td>
                                                        <Td>{reciba.numerodeParte}</Td>
                                                        <Td >{reciba.descripcion}</Td>
                                                        <Td className={reciba.descripcion ? "" : "margintopmobil20px"}>{reciba.fechaDeReciba}</Td>
                                                        <Td >{reciba.FEPlanta}</Td>
                                                        <Td >{reciba.packing}</Td>
                                                        <Td >{reciba.lote}</Td>
                                                        <Td >{reciba.serial}</Td>
                                                        <Td >{reciba.serialRecibaBTI}
                                                            {ppmarcarFueraPlanta === true && (
                                                                <button className="cbutton  floatright  ml-2 btn-danger mb-3"
                                                                    title="Marcar fuera de planta"
                                                                    onClick={() => { marcarMaterialFueradePlantal(reciba); }}
                                                                > <IoIcons.IoIosAnalytics /></button>)}
                                                        </Td>
                                                        <Td >{reciba.cantidadRecibida}</Td>
                                                        <Td >  {reciba.EEstatus}</Td>
                                                        <Td >{reciba.enCuarentena}</Td>
                                                        <Td >{reciba.cantidadPlaneada ? reciba.cantidadPlaneada : 0}</Td>
                                                        <Td >{reciba.piezasenAlmacen ? reciba.piezasenAlmacen : 0}</Td>
                                                        <Td >{reciba.enCarga}</Td>

                                                        <Td >{reciba.enPintado}</Td>

                                                        <Td >{reciba.enInspeccion}</Td>

                                                        <Td >{reciba.enRecuperacion}</Td>

                                                        <Td >{reciba.piezasAEmbarcar ? reciba.piezasAEmbarcar : 0}</Td>

                                                        <Td >{reciba.piezasEmbarcadas ? reciba.piezasEmbarcadas : 0}</Td>
                                                        <Td >  {reciba.materialEnCantidad + " " + (reciba.materialEnCantidad > 1 ?
                                                            reciba.materialEn === "caja" ? "cajas" : "contenedores" : reciba.materialEn)}</Td>
                                                        <Td >{reciba.Reg_Ins_Usuario}</Td>
                                                        <Td >{reciba.comentariosdeinspeccion}</Td>

                                                    </Tr>

                                                ))}
                                            </Tbody>
                                        </Table>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                        <h5 className="floatcenter mb-4">{sumProduccionp + "   " + sumICiclos}</h5>
                                    </div>
                                </Row>
                                <div className='displaynone'>
                                    <div ref={componentRef}>
                                        <div  >
                                            <img className="floatleft ml-3 mb-4" src="assets/img/Logo/logost.png " />

                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter" >
                                                {recibaSeriales.length > 0 && (<h5 className=" ">Reporte de producción del {Moment(rfechaini).format("DD/MM/YYYY")} al  {Moment(rfechafin).format("DD/MM/YYYY")}</h5>)}
                                            </div>
                                        </div>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                            <Table className=" mb-2  " >
                                                <Thead className="thead-secondary">
                                                    <Tr>
                                                        <Th>Número</Th>
                                                        <Th className="minwidth200px">Cliente</Th>
                                                        <Th className="minwidth100px">Número de parte</Th>
                                                        <Th className="">Descripción</Th>
                                                        <Th className="minwidth100px">Fecha de reciba</Th>
                                                        <Th className="">Packing</Th>
                                                        <Th className="">Lote</Th>
                                                        <Th className="">Serial</Th>
                                                        <Th className="minwidth100px">Serial BTI</Th>
                                                        <Th>Cantidad recibida</Th>
                                                        <Th className="">Estatus</Th>
                                                        {/*<Th className="minwidth60px">Piezas en cuarentena</Th>
                                                    <Th className="minwidth60px">Cantidad planeada</Th>
                                                    <Th className="minwidth60px">Piezas en almacén</Th>
                                                    <Th className="minwidth60px">Piezas en carga</Th>
                                                    <Th className="minwidth60px">Piezas en pintado</Th>
                                                    <Th className="minwidth60px">Piezas en inspección</Th>
                                                    <Th className="minwidth60px">En Recuperacion</Th>
                                                    <Th className="minwidth60px">Piezas a embarcar</Th>
                                                        <Th className="minwidth60px">Piezas embarcadas</Th>*/}
                                                        <Th className="">Contenedor de reciba</Th>
                                                        <Th className="">Recibió</Th>
                                                        <Th className="">Comentarios</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {recibaSeriales.map((reciba, i) => (
                                                        <Tr className={(i % 2) !== 0 ? "table-active" : ""} >
                                                            <Td>{i + 1}</Td>
                                                            <Td>{reciba.cliente}</Td>
                                                            <Td>{reciba.numerodeParte}</Td>
                                                            <Td >{reciba.descripcion}</Td>
                                                            <Td className={reciba.descripcion ? "" : "margintopmobil20px"}>{reciba.fechaDeReciba}</Td>
                                                            <Td >{reciba.packing}</Td>
                                                            <Td >{reciba.lote}</Td>
                                                            <Td >{reciba.serial}</Td>
                                                            <Td >{reciba.serialRecibaBTI}</Td>
                                                            <Td >{reciba.cantidadRecibida}</Td>
                                                            <Td >  {reciba.EEstatus}</Td>
                                                            <Td >  {reciba.materialEnCantidad + " " + (reciba.materialEnCantidad > 1 ?
                                                                reciba.materialEn === "caja" ? "cajas" : "contenedores" : reciba.materialEn)}</Td>
                                                            <Td >{reciba.Reg_Ins_Usuario}</Td>
                                                            <Td >{reciba.comentariosdeinspeccion}</Td>

                                                        </Tr>

                                                    ))}
                                                </Tbody>
                                            </Table>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                                            <h5 className="floatcenter mb-4">{sumProduccionp + "   " + sumICiclos}</h5>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pProduccionSinFiltro)}</div>*/}
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(planeacionSinFiltro)}</div>*/}
                            </div>
                        </Fragment>
                    </div>
                </>
            )
            }
        </>
    )
};



export default RIClinentes;
